module.exports = __webpack_public_path__ + "media/images/logo/fakturaonline-square-logo-nl-4e6872b648b45cfd4da298e9c5b2efa9.svg";